import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["subscreen"],
  _excluded2 = ["subscreen"];
import { EVENT_ACTIONS, EVENT_NAMES } from './eventProperties';
import { EVENT_NAMESPACE } from './eventProperties';
export const cloneTracker = usageTracker => {
  return usageTracker.clone({
    standalone: true
  });
};
export const trackView = (usageTracker, options) => {
  const {
      subscreen
    } = options,
    rest = _objectWithoutPropertiesLoose(options, _excluded);
  cloneTracker(usageTracker).track(EVENT_NAMESPACE, EVENT_NAMES.COMPONENT_VIEWED, Object.assign({}, rest, subscreen && {
    subscreen
  }));
};
export const trackClick = (usageTracker, options) => {
  const {
      subscreen
    } = options,
    rest = _objectWithoutPropertiesLoose(options, _excluded2);
  cloneTracker(usageTracker).track(EVENT_NAMESPACE, EVENT_NAMES.COMPONENT_INTERACTED, Object.assign({}, rest, subscreen && {
    subscreen
  }, {
    action: EVENT_ACTIONS.CLICK
  }));
};
export const trackTooltipOpen = (usageTracker, options) => {
  cloneTracker(usageTracker).track(EVENT_NAMESPACE, EVENT_NAMES.COMPONENT_INTERACTED, Object.assign({}, options, {
    action: EVENT_ACTIONS.TOOLTIP_OPEN
  }));
};
export const trackTimeFrameChange = (usageTracker, options) => {
  cloneTracker(usageTracker).track(EVENT_NAMESPACE, EVENT_NAMES.COMPONENT_INTERACTED, Object.assign({}, options, {
    action: EVENT_ACTIONS.TIME_FRAME_CHANGE
  }));
};
export const trackDateRangeChange = (usageTracker, options) => {
  cloneTracker(usageTracker).track(EVENT_NAMESPACE, EVENT_NAMES.COMPONENT_INTERACTED, Object.assign({}, options, {
    action: EVENT_ACTIONS.DATE_RANGE_CHANGE
  }));
};
export const trackToggleChange = (usageTracker, options) => {
  cloneTracker(usageTracker).track(EVENT_NAMESPACE, EVENT_NAMES.COMPONENT_INTERACTED, Object.assign({}, options, {
    action: EVENT_ACTIONS.TOGGLE_CHANGE
  }));
};